import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { Foldable } from '../../ui-kit/Foldable/Foldable.js';
import { FoldableSection } from '../../ui-kit/Foldable/FoldableSection.js';
import { Icon } from '../../ui-kit/Icon/Icon.js';
import { Text } from '../../ui-kit/Text/Text.js';
import { Badge } from './Badge.js';
import { CardCell } from './CardCell.js';
import { CardRow } from './CardRow.js';
import { renderFoldButton } from './renderFoldButton.js';
export const renderAtmCard = ({ location, address, billAcceptorType, terminalType, billAcceptorEnable, atmCode = '', atmAccess = '', workTime, }, i) => {
    const additionalInfo = [
        {
            label: 'Устройство',
            value: capitalizedFirstLetter(terminalType),
        },
        { label: 'Модуль приема наличных', value: billAcceptorEnable ? 'Да' : 'Нет' },
        {
            label: 'Прием наличных пачкой',
            value: billAcceptorType === 'банкомат принимает пачками' ? 'Да' : 'Нет',
        },
        {
            label: 'Доступность',
            value: ['внешняя установка', 'территория банка'].includes(atmAccess) ? 'Общедоступный' : '',
        },
        { label: 'Регистрационный номер', value: atmCode },
    ];
    return (_jsxs("div", { className: "bg-white col-span-12 p-3xl sm:border-green sm:border", children: [_jsxs("div", { className: "sm:flex sm:justify-between", children: [_jsxs("div", { children: [_jsx(Text, { size: "text-h4", children: capitalizedFirstLetter(location) }), address ? (_jsxs("div", { className: "flex pb-xl pt-xs gap-2xs", children: [_jsx(Icon, { name: "GeolocationIcon", width: "24", height: "24" }), _jsx(Text, { size: "text-l", children: address })] })) : null] }), _jsx("div", { className: "whitespace-nowrap", children: _jsx(Badge, { color: "green", children: capitalizedFirstLetter(workTime) }) })] }), _jsx("div", { className: "hidden sm:block", children: _jsx(CardRow, { className: "flex-wrap", children: additionalInfo?.map(renderInfo) }) }), _jsx(Foldable, { className: "block sm:hidden", renderFoldableSection: ({ isUnfolded }) => {
                    return (_jsx(FoldableSection, { isUnfolded: isUnfolded, children: _jsx(CardRow, { className: "flex-wrap", children: additionalInfo?.map(renderInfo) }) }));
                }, 
                //** TODO: Remove styles with refactoring  DefaultFoldButton*/
                renderFoldButton: ({ isUnfolded, onToggle }) => renderFoldButton({ isUnfolded, onToggle }) })] }, String(i)));
};
export const getAtmPoint = ({ address = '', terminalType, atmCode = '' }) => {
    const header = `${capitalizedFirstLetter(terminalType)} №${atmCode}`;
    const body = address.toUpperCase();
    return { header, body };
};
const renderInfo = (item, i) => (_jsx(CardCell, { ...item }, String(i)));
const capitalizedFirstLetter = (text) => text ? `${text?.charAt(0)?.toUpperCase()}${text?.slice(1)}` : '';
//# sourceMappingURL=renderAtmCard.js.map